var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-jumbotron',{staticClass:"info-block",attrs:{"header":_vm.title,"lead":_vm.lead,"bg-variant":_vm.bgVariant,"text-variant":_vm.textVariant}},[_c('p',[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }